import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './footer.scss';
import LogoMiBanco from '@assets/icons/logo-mi-banco-footer-green.svg';
const Footer = () => {
    const currentYear = new Date().getFullYear();
    return (_jsx("footer", { className: "footer", children: _jsxs("div", { className: 'footer-center', children: [_jsx("div", { className: 'footer_image', children: _jsx("img", { src: LogoMiBanco, alt: "logo-mibanco-footer", loading: "lazy" }) }), _jsx("div", { className: 'footer_info', children: _jsxs("span", { children: ["\u00A9 Copyright ", currentYear, " - Todos los derechos reservados"] }) })] }) }));
};
export default Footer;
